export const ROUTE_CATEGORY_BREADCRUMB = 'breadcrumb',
  ROUTE_CATEGORY_COLLECTION = 'collection',
  ROUTE_CATEGORY_ROOT_COLLECTION = 'root-collection';
